import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-2xl w-full bg-white rounded-[48px] shadow-2xl p-12 md:p-20 text-center border border-slate-200 relative overflow-hidden"
      >
        {/* Decorative background elements */}
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-blue-50 rounded-full blur-3xl opacity-50" />
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-emerald-50 rounded-full blur-3xl opacity-50" />

        <div className="relative">
          <div className="w-24 h-24 bg-emerald-500 rounded-[32px] flex items-center justify-center mx-auto mb-10 text-white shadow-xl shadow-emerald-100 rotate-3">
            <SafeIcon name="Check" className="w-12 h-12" />
          </div>

          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 tracking-tight">
            Thank You
          </h1>
          
          <p className="text-slate-500 text-lg font-medium leading-relaxed max-w-md mx-auto">
            We’ve received your responses.<br />
            We’re reviewing them and will be in touch shortly.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default ThankYou;